import { Outlet, Link } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

// Minimal chrome for the public /wiki surface. Doesn't depend on auth —
// renders for signed-in users and anonymous readers alike. The actual
// app's TopNav requires a user payload, so we wear a smaller header here.
export default function WikiLayout() {
  const { isAuthed, user } = useAuth();

  return (
    <div className="wiki-public">
      <header className="wiki-public-header">
        <Link to="/wiki" className="wiki-public-brand">
          UNEARTH<span>WORX</span>
          <small>WIKI</small>
        </Link>
        <div className="wiki-public-actions">
          {isAuthed ? (
            <>
              <span style={{ fontSize: 12, color: 'var(--warm-gray)' }}>
                {user?.display_name}
              </span>
              <Link to="/clock" className="btn-sm">
                <i className="ph ph-arrow-left" /> Back to app
              </Link>
            </>
          ) : (
            <Link to="/login" className="btn-sm primary">
              <i className="ph ph-discord-logo" /> Sign in
            </Link>
          )}
        </div>
      </header>
      <main className="wiki-public-main">
        <Outlet />
      </main>
    </div>
  );
}
